import { render, staticRenderFns } from "./GiveAndAskCategoriesPostReport.vue?vue&type=template&id=2e30ecc8"
import script from "./GiveAndAskCategoriesPostReport.vue?vue&type=script&lang=js"
export * from "./GiveAndAskCategoriesPostReport.vue?vue&type=script&lang=js"
import style0 from "./GiveAndAskCategoriesPostReport.vue?vue&type=style&index=0&id=2e30ecc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports